'use client';

import { useIntl } from 'react-intl';

import { Link } from '@packages/modules/src/Link/Link';
import type { MessageTag } from 'react-intl';

export const EcoLabelsHintLink = () => {
  const { formatMessage } = useIntl();

  const serviceLink = formatMessage({
    defaultMessage: '/service-hilfe/verantwortung ',
    id: 'ecoLabels.hint.link.url',
  });

  return (
    <div className="text-size-body-sm">
      {formatMessage<{ readonly link: MessageTag }>(
        {
          defaultMessage: 'Erfahre mehr zu unseren <link>Kriterien für Produktstandards</link>',
          id: 'ecoLabels.hint.link',
        },
        {
          link: (chunks: React.ReactNode) => (
            <Link href={serviceLink} className="underline">
              {chunks}
            </Link>
          ),
        },
      )}
    </div>
  );
};
